import SsoActionTypes from './sso.types';
import { getParameterByName } from '../../utils/commonFunctions';

var token = getParameterByName('token');
var referer = getParameterByName('referer');
var returnPath = getParameterByName('return_path');
var sso = 1;
if (typeof token === undefined) {
	window.location.href = 'login';
}
if (referer === 'landing') {
	sso = 0;
	localStorage.setItem('TriggerBuyNow', 'Yes');
	localStorage.setItem('is_subscription', getParameterByName('is_subscription'));
	localStorage.setItem('payment_method', getParameterByName('payment_method'));
	localStorage.setItem('new_user', getParameterByName('new_user'));
	localStorage.setItem('referer', referer);
	localStorage.setItem('paymentInProcess', 1);
} else {
	sso = 1;
}
returnPath = (!!returnPath ? returnPath : '/mydashboard').split('?');

const initialSsoState = {
	error: '',
	success: false,
	token,
	sso,
	returnPath: returnPath[0],
	returnSearch: !!returnPath[1] ? '?' + returnPath[1] : '',
	referer,
};

export const ssoDetails = (state = initialSsoState, action = {}) => {
	switch (action.type) {
		case SsoActionTypes.VALIDATE_USER.SUCCESS:
			return Object.assign({}, state, { success: true });
		default:
			return state;
	}
};
